export const RESTORE_SESSION_REQUESTED = 'RESTORE_SESSION_REQUESTED'
export const RESTORE_SESSION_FAILED = 'RESTORE_SESSION_FAILED'
export const RESTORE_SESSION_DONE = 'RESTORE_SESSION_DONE'
export const DELETE_SESSION_REQUESTED = 'DELETE_SESSION_REQUESTED'
export const DELETE_SESSION_FAILED = 'DELETE_SESSION_FAILED'
export const DELETE_SESSION_DONE = 'DELETE_SESSION_DONE'
